// import cx from 'classnames';
import { func } from 'prop-types';
import React from 'react';

import { ReactComponent as SmartbeLogo } from '../../assets/smartbe_logo.svg';
import Button from '../../components/Button';

import s from './index.module.css';


const Header = ({ onBtnClick }) => (
  <header className={s.appHeader}>
    <section className={s.headerContent}>
      <a className={s.headerLogoLink} href="/">
        <SmartbeLogo className={s.smartbeLogo} />
      </a>
      <h1 className={s.sectionHeader}>
        Помогаем магазинам автозапчастей увеличить продажи
      </h1>
      <div className={s.btnWrapper}>
        <Button className={s.submitBtn} type="button" onClick={onBtnClick}>Подключить магазин</Button>
      </div>
    </section>
    <div className={s.headerBanner}></div>
  </header>
);

Header.propTypes = {
  onBtnClick: func,
};

Header.defaultProps = {
  onBtnClick: () => { },
};

export default Header;
